import { render, staticRenderFns } from "./TasksGantt.vue?vue&type=template&id=1a75a9be"
import script from "./TasksGantt.vue?vue&type=script&lang=js"
export * from "./TasksGantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports